<template>
<v-container id="dashboard" fluid tag="section">

</v-container>
</template>



<script>
var colors_bars = [
    "#eb7601", //naranja
    "#ffde17", //amarillo
    "#006594", //azul
    "#56baec", // azul cielo
    "#ffffff" // azul cielo
];
import axios from "axios";
import moment from "moment";
//import Canvg from 'canvg';
import jsPDF from 'jspdf';
//import html2canvas from 'html2canvas';

//window.html2canvas = html2canvas

export default {
    name: "DashboardDashboard",

    data() {
        return {
            ver: false,
            anio_recuperacion: "",
            titulo_detalle: "",
            valid: true,
            loader: null,
            loading: false,
            pedimentosB: 0,
            remesasB: 0,
            consultaB: "",
            consultaC: {
                "impo": 0,
                "expo": 0
            },
            consultaD: "",
            coneliminados: false,
            consultaG1: "",
            consultaG2: "",
            consultaG3: "",

            tablaB: "",
            impoC: 0,
            expoC: 0,
            impoD: 0,
            expoD: 0,
            filtroB: "",
            correctos: 0,
            incorrectos: 0,
            selected: 1,
            fab: false,
            dialog1: false,
            dialog2: false,
            dialog3: false,
            menuB: false,
            menuC: false,
            menuD: false,
            dialogA1: false,
            dialogB1: false,
            dialogC1: false,
            dialogD1: false,
            dialogA2: false,
            dialogB2: false,
            dialogC2: false,
            dialogD2: false,
            menuA1: false,
            menuA2: false,
            menuB1: false,
            menuB2: false,
            menuC1: false,
            menuC2: false,
            menuD1: false,
            menuD2: false,
            fechaA_de: "",
            fechaA_a: "",
            fechaB_de: "",
            fechaB_a: "",
            fechaC_de: "",
            fechaC_a: "",
            fechaD_de: "",
            fechaD_a: "",
            mesB: "",
            mesC: "",
            mesD: "",
            mes1: "",
            mes2: "",
            mes3: "",
            a1: "",
            a2: "",
            a3: "",

            data_grafica1: {
                chart: {
                    type: "spline",
                    backgroundColor: null,
                    height: 150,
                    spacingBottom: 2,
                    spacingTop: 2,
                    spacingLeft: 2,
                    spacingRight: 2,
                    marginRight: 2,
                    marginLeft: 40,
                    marginTop: 2,
                    marginBottom: 30,

                },

                credits: {
                    enabled: false
                },
                csecondaryits: false,
                title: {
                    text: ""
                },
                plotOptions: {
                    candlestick: {
                        lineColor: 'secondary'
                    }
                },
                navigator: {
                    yAxis: {
                        gridLineColor: '#000'
                    }
                },
                colors: colors_bars,
                xAxis: {
                    categories: [],
                    gridLineWidth: 0,
                    labels: {
                        style: {
                            color: '#E0E0E3',
                            fontSize: '9px'
                        }
                    },

                },

                yAxis: {
                    allowDecimals: false,
                    gridLineWidth: 0,
                    minorGridLineWidth: 0.1,
                    minorTicks: true,
                    min: 0,
                    title: {
                        text: "",
                    },
                    labels: {
                        style: {
                            color: '#E0E0E3',
                            fontSize: '9px'
                        }
                    },
                },

                tooltip: {
                    formatter: function () {
                        return (
                            this.series.name + ": " + this.y
                        );
                    }
                },

                plotOptions: {
                    column: {
                        stacking: "normal"
                    }
                },
                legend: {
                    enabled: false
                },
                series: [{
                        name: "Pedimentos",
                        data: [],
                        stack: "Pedimentos"
                    },
                    {
                        name: "Remesas",
                        data: [],
                        stack: "Remesas"
                    },
                    {
                        name: "Rectificaciones",
                        data: [],
                        stack: "Rectificaciones"
                    },

                ]
            },
            totalA_G1: 0,
            totalR_G1: 0,
            totalB_G1: 0,
            data_grafica2: {

                chart: {
                    type: "spline",
                    backgroundColor: null,
                    height: 150,
                    spacingBottom: 2,
                    spacingTop: 2,
                    spacingLeft: 2,
                    spacingRight: 2,
                    marginRight: 2,
                    marginLeft: 40,
                    marginTop: 2,
                    marginBottom: 30,

                },
                credits: {
                    enabled: false
                },
                csecondaryits: false,
                title: {
                    text: ""
                },
                plotOptions: {
                    candlestick: {
                        lineColor: 'secondary'
                    }
                },
                navigator: {
                    yAxis: {
                        gridLineColor: '#000'
                    }
                },
                colors: colors_bars,
                xAxis: {
                    categories: [],
                    gridLineWidth: 0,
                    labels: {
                        style: {
                            color: '#E0E0E3',
                            fontSize: '9px'
                        }
                    },

                },

                yAxis: {
                    allowDecimals: false,
                    gridLineWidth: 0,
                    minorGridLineWidth: 0.1,
                    minorTicks: true,
                    min: 0,
                    title: {
                        text: "",
                    },
                    labels: {
                        style: {
                            color: '#E0E0E3',
                            fontSize: '9px'
                        }
                    },
                },

                tooltip: {
                    formatter: function () {
                        return (
                            this.series.name + ": " + this.y
                        );
                    }
                },

                plotOptions: {
                    column: {
                        stacking: "normal"
                    }
                },
                legend: {
                    enabled: false
                },
                series: [{
                        name: "Pedimentos",
                        data: [],
                        stack: "Pedimentos"
                    },
                    {
                        name: "Remesas",
                        data: [],
                        stack: "Remesas"
                    },
                    {
                        name: "Rectificaciones",
                        data: [],
                        stack: "Rectificaciones"
                    },

                ]
            },
            totalA_G2: 0,
            totalR_G2: 0,
            totalB_G2: 0,
            data_grafica3: {
                chart: {
                    type: "spline",
                    backgroundColor: null,
                    height: 150,
                    spacingBottom: 2,
                    spacingTop: 2,
                    spacingLeft: 2,
                    spacingRight: 2,
                    marginRight: 2,
                    marginLeft: 40,
                    marginTop: 2,
                    marginBottom: 30,

                },
                credits: {
                    enabled: false
                },
                csecondaryits: false,
                title: {
                    text: ""
                },
                plotOptions: {
                    candlestick: {
                        lineColor: 'secondary'
                    }
                },
                navigator: {
                    yAxis: {
                        gridLineColor: '#000'
                    }
                },
                colors: colors_bars,
                xAxis: {
                    categories: [],
                    gridLineWidth: 0,
                    labels: {
                        style: {
                            color: '#E0E0E3',
                            fontSize: '9px'
                        }
                    },

                },

                yAxis: {
                    allowDecimals: false,
                    gridLineWidth: 0,
                    minorGridLineWidth: 0.1,
                    minorTicks: true,
                    min: 0,
                    title: {
                        text: "",
                    },
                    labels: {
                        style: {
                            color: '#E0E0E3',
                            fontSize: '9px'
                        }
                    },
                },

                tooltip: {
                    formatter: function () {
                        return (
                            this.series.name + ": " + this.y
                        );
                    }
                },

                plotOptions: {
                    column: {
                        stacking: "normal"
                    }
                },
                legend: {
                    enabled: false
                },
                series: [{
                        name: "Pedimentos Importaciones",
                        data: [],
                        stack: "Pedimentos Importaciones"
                    },
                    {
                        name: "Pedimentos Exportaciones",
                        data: [],
                        stack: "Pedimentos Exportaciones"
                    },
                    {
                        name: "Remesas Importaciones",
                        data: [],
                        stack: "Remesas Importaciones"
                    },
                    {
                        name: "Remesas Exportaciones",
                        data: [],
                        stack: "Remesas Exportaciones"
                    },
                    {
                        name: "Complementarios",
                        data: [],
                        stack: "Complementarios"
                    },

                ]
            },
            totalA_G3: 0,
            totalB_G3: 0,
            totalC_G3: 0,
            totalD_G3: 0,
            totalD_CT: 0,

            //MENSAJES DE CORREO
            data_tableA: [],
            columns_tableA: [
                "usuario",
                "referencia",
                "estatus",
                "error",
                "fecha",
                "mensaje",
            ],
            tableA_options: {
                filterable: true,
                filterByColumn: false,
                texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
                headings: {
                    "Usuario": "usuario",
                    "Referencia": "referencia",
                    "Estatus": "estatus",
                    "Error": "error",
                    "Fecha": "fecha",
                    "Mensaje": "mensaje"
                }
            },
            data_tableA_excel: {
                "Usuario": "usuario",
                "Referencia": "referencia",
                "Estatus": "estatus",
                "Error": "error",
                "Fecha": "fecha",
                "Mensaje": "mensaje"
            },

            //////////////////

            //TABLA CONSULTA DIARIA
            data_tableB: [],
            columns_tableB: [
                "NoPedimento",
                "FechaPagoReal",
                "TipoOperacion",
                "ClaveDocumento",
                "TipoDocumento",
                "TipoCambio",
                "ValorComercial",
                "PesoBruto",
                "CuentaRemesas"
            ],
            tableB_options: {
                filterable: true,
                filterByColumn: false,
                texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
                orderBy: {
                    column: 'FechaPagoReal',
                    ascending: false
                },
                headings: {
                    "NoPedimento": "No. de Pedimento",
                    "FechaPagoReal": "Fecha Pago Real",
                    "TipoOperacion": "Tipo Operación",
                    "ClaveDocumento": "Clave Documento",
                    "TipoDocumento": "Tipo Documento",
                    "TipoCambio": "Tipo Cambio",
                    "ValorComercial": "Valor Comercial",
                    "PesoBruto": "Peso Bruto",
                    "CuentaRemesas": "Cuenta Remesas",
                }
            },
            data_tableB_excel: {

                "No. de Pedimento": "NoPedimento",
                "Fecha Pago Real": "FechaPagoReal",
                "Tipo Operación": "TipoOperacion",
                "Clave Documento": "ClaveDocumento",
                "Tipo Documento": "TipoDocumento",
                "Tipo Cambio": "TipoCambio",
                "Valor Comercial": "ValorComercial",
                "Peso Bruto": "PesoBruto",
                "Cuenta Remesas": "CuentaRemesas",
                "Medio Transporte": "MedioTransporte",
                "No. Operación": "NoOperacion"
            },

            //TABLA REVISION
            data_tableC: [],
            columns_tableC: [
                "NoPedimento",
                "FechaPagoReal",
                "TipoOperacion",
                "ClaveDocumento",
                "TipoDocumento",
                "Estado",
                "DescripcionEstado",
                "SubEstado",
                "DescripcionSubEstado",
                "FechaCambio",
                "Secuencia",
                "Factura",
                "Cantidad",
                "Valor"

            ],
            tableC_options: {
                filterable: true,
                filterByColumn: false,
                texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
                orderBy: {
                    column: 'FechaPagoReal',
                    ascending: false
                },
                headings: {
                    "NoPedimento": "No. Pedimento",
                    "FechaPagoReal": "Fecha Pago",
                    "TipoOperacion": "Tipo Operación",
                    "ClaveDocumento": "Clave Documento",
                    "TipoDocumento": "Tipo Documento",
                    "Estado": "Estado",
                    "DescripcionEstado": "Descripción Estado",
                    "SubEstado": "Subestado",
                    "DescripcionSubEstado": "Descripción Subestado",
                    "FechaCambio": "Fecha Cambio",
                    "Secuencia": "Secuencia",
                    "Factura": "Factura",
                    "Cantidad": "Cantidad",
                    "Valor": "Valor"
                }
            },
            data_tableC_excel: {
                "No. Pedimento": "NoPedimento",
                "Fecha Pago": "FechaPagoReal",
                "Tipo Operación": "TipoOperacion",
                "Clave Documento": "ClaveDocumento",
                "Tipo Documento": "TipoDocumento",
                "Fecha Estado": "FechaEstado",
                "Descripción": "Descripcion",
                "Numéro Prevalidador": "NumeroPrevalidador",
                "Estado": "Estado",
                "Descripción Edo.": "DescripcionEstado",
                "Subestado": "SubEstado",
                "Descripción Subestado": "DescripcionSubEstado",
                "Fecha Cambio": "FechaCambio",
                "Secuencia": "Secuencia",
                "Factura": "Factura",
                "Cantidad": "Cantidad",
                "Valor": "Valor"

            },

            //TABLA DETALLE GRAFICAS
            data_tableG: [],
            columns_tableG: [
                "tipo_operacion",
                "mes",
                "pedimentos",
                "remesas",
                "peso_bruto_p",
                "valor_dls_p",
                "valor_total_p",
                "rectificaciones",
                "peso_bruto_r",
                "valor_dls_r",
                "valor_total_r",

            ],
            tableG_options: {
                filterable: false,
                filterByColumn: false,
                perPage: 100,
                orderBy: {
                    column: 'mes',
                    ascending: true
                },
                headings: {
                    "tipo_operacion": "Tipo Operación",
                    "mes": "Mes",
                    "pedimentos": "Pedimentos",
                    "remesas": "Remesas",
                    "peso_bruto_p": "Peso Bruto",
                    "valor_dls_p": "Valor DLS",
                    "valor_total_p": "Valor MN",
                    "rectificaciones": "Rectificaciones",
                    "peso_bruto_r": "Peso Bruto Rectificaciones",
                    "valor_dls_r": "Valor DLS Rectificaciones",
                    "valor_total_r": "Valor MN Rectificaciones",
                }
            },
            data_tableG_excel: {
                "Tipo Operación": "tipo_operacion",
                "Mes": "mes",
                "Pedimento": "pedimentos",
                "Remesas": "remesas",
                "Peso Bruto": "peso_bruto_p",
                "Valor Dolares": "valor_dls_p",
                "Valor Total": "valor_total_p",
                "Rectificaciones": "rectificaciones",
                "Peso Bruto Rectificaciones": "peso_bruto_r",
                "Valor DLS Rectificaciones": "valor_dls_r",
                "Valor MN Rectificaciones": "valor_total_r",

            },

            //TABLA REVISION
            data_tableD: [],
            columns_tableD: [
                "NoPedimento",
                "FechaPagoReal",
                "TipoOperacion",
                "ClaveDocumento",
                "TipoDocumento",
                "Estado",
                "DescripcionEstado",
                "SubEstado",
                "DescripcionSubEstado",
                "FechaCambio",
                "Secuencia",
                "Factura",
                "Cantidad",
                "Valor"

            ],
            tableD_options: {
                filterable: true,
                filterByColumn: false,
                texts: {
                    filter: '',
                    filterPlaceholder: 'Buscar',
                },
                orderBy: {
                    column: 'FechaPagoReal',
                    ascending: false
                },
                headings: {
                    "NoPedimento": "No. Pedimento",
                    "FechaPagoReal": "Fecha Pago",
                    "TipoOperacion": "Tipo Operación",
                    "ClaveDocumento": "Clave Documento",
                    "TipoDocumento": "Tipo Documento",
                    "Estado": "Estado",
                    "DescripcionEstado": "Descripción Edo.",
                    "SubEstado": "Subestado",
                    "DescripcionSubEstado": "Descripción Subestado",
                    "FechaCambio": "Fecha Cambio",
                    "Secuencia": "Secuencia",
                    "Factura": "Factura",
                    "Cantidad": "Cantidad",
                    "Valor": "Valor"
                }
            },
            data_tableD_excel: {
                "No. Pedimento": "NoPedimento",
                "Fecha Pago": "FechaPagoReal",
                "Tipo Operación": "TipoOperacion",
                "Clave Documento": "ClaveDocumento",
                "Tipo Documento": "TipoDocumento",
                "Descripción": "Descripcion",
                "Numéro Prevalidador": "NumeroPrevalidador",
                "Estado": "Estado",
                "Descripción Edo.": "DescripcionEstado",
                "Subestado": "SubEstado",
                "Descripción Subestado": "DescripcionSubEstado",
                "Fecha Cambio": "FechaCambio",
                "Secuencia": "Secuencia",
                "Factura": "Factura",
                "Cantidad": "Cantidad",
                "Valor": "Valor"
            },
        };
    },

    computed: {
        soloSoluciona() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100 && this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100 &&
                this.$local_storage.get("Reportes.ecosting.consulta.facturas") != 100 && this.$local_storage.get("EmanifiestoCP.bitacora") != 100 &&
                this.$local_storage.get("EmanifiestoAA.edrive.consultar") != 100 &&
                (this.$local_storage.get("EmanifiestoMV.bitacora") != 100) && this.$local_storage.get("Logistica.nuevoregistro") != 100 &&
                (this.$local_storage.get("Modulo15") == 100 || this.$local_storage.get("Modulo16") == 100);
        },
        expediente() {
            return (

                this.$local_storage.get(
                    "BANDEJA.DE.CORREO"
                ) == 100
            );
        },
        is_consignatario() {
            return this.$local_storage.get("subtipo_usuario") == "embarcadores_consignatarios";
        },
        anios() {
            var f = new Date();
            let a = [];
            let y = f.getFullYear();
            let i = 1;
            for (i; i < 15; i++) {
                a.push(y)
                y = y - 1;
            }
            return a;
        },

        soloEmanifiesto() {
            return this.$local_storage.get("DATA.STAGE.bitacora") != 100 && this.$local_storage.get("VUCEM.Transmision.nuevo.cove") != 100 &&
                this.$local_storage.get("Reportes.ecosting.consulta.facturas") != 100 && this.$local_storage.get("Emanifiesto.bitacora") == 100;
        },
    },

    mounted() {

        if (this.$local_storage.get("es_transportista") == 1)
            this.$router.replace("/indext").catch(() => {});
        else
        if (this.$local_storage.get("es_agente") == 1)
            this.$router.replace("/indexAA").catch(() => {});
        else
        if (this.$local_storage.get("soloCartaPorte") == 100)
            this.$router.replace("/indext").catch(() => {});
        else
        if (this.$local_storage.get("Modulo14") == 100 && this.$local_storage.get("id_cliente") > 0)
            this.$router.replace("/indexAAC").catch(() => {});
        else
        if (this.$store.state.emanifiesto == true)
            this.$router.replace("/manifestacion/transmitir").catch(() => {});
        else
        if (this.$store.state.costing == true)
            this.$router.replace("/facturastransito").catch(() => {});
        else
        if (this.$store.state.trafico == true)
            this.$router.replace("/trafico_index").catch(() => {});
        else
        if (this.$store.state.sa31 == true || this.$local_storage.get("soloSA31") == 100)
            this.$router.replace("/indexsa31").catch(() => {});
        else
        if (this.$local_storage.get("perfil_grupo") == 43) {
            this.$router.replace("/trafico/reporte_embarques").catch(() => {});
        }
        else
        if (this.$local_storage.get("VUCEM.Pedimento.consulta.pedimento") == 0 && this.$local_storage.get("VUCEM.Pedimento.consulta.cove") == 0) {
            if (this.$local_storage.get("DATA.STAGE.cargazip") == 100)
                this.$router.replace("/datastage/bitacorazip").catch(() => {});
            else if (this.$local_storage.get("VUCEM.Transmision.ver.coves") == 100)
                this.$router.replace("/transmision/covedetalles").catch(() => {});
            else if (this.$local_storage.get("VUCEM.Pedimento.consulta.pedimento") == 100)
                this.$router.replace("/reportes/consultar_pedimentos_ws").catch(() => {});
            else
                this.$router.replace("/home").catch(() => {});

        }

    },

};
</script>
